import React from 'react';
import { DownloadIcon } from 'lucide-react';
import { faqs, SAMPLE_URL } from '../data/content';
import { SectionTitle } from './SectionTitle';
import { Accordion } from './Accordion';
export function FaqSection() {
  return <section className="bg-cream px-5 py-10 sm:px-8 lg:py-14" data-id="element-37" data-mp="1blu0gnjkxc6v">
      <div className="mx-auto w-full max-w-[840px]" data-id="element-38" data-mp="1gjbyhiw26703">
        <SectionTitle className="uppercase" data-id="element-39" data-mp="1gjvkbaotxfje">Preguntas frecuentes</SectionTitle>
        <div className="mt-6 space-y-3" data-id="element-40" data-mp="24ahga3lk79d1">
          {faqs.map((faq, i) => <Accordion key={faq.question} id={`faq-${i + 1}`} className="bg-white" openClassName="bg-white" header={<span className="flex items-start gap-4" data-id="element-42" data-mp="1ujwkenx9sixt">
                  <span className="font-display text-[15px] font-semibold text-coral" data-id="element-43" data-mp="1uhadmqi7e7gn">
                    {String(i + 1).padStart(2, '0')}
                  </span>
                  <span className="font-sans text-[16px] font-bold leading-snug text-ink sm:text-[17px]" data-id="element-44" data-mp="2n70rqzju59cr">
                    {faq.question}
                  </span>
                </span>} data-id="element-41" data-mp="28ajiqez4c6td" data-mpi={i}>
              <p className="pl-[31px] font-sans text-[16px] leading-relaxed text-ink-soft" data-id="element-45" data-mp="14uirjj4hylre">
                {faq.answer}
              </p>
            </Accordion>)}
        </div>

        <div className="mx-auto mt-8 max-w-[560px] rounded-2xl border border-coral/30 bg-white px-6 py-7 text-center" data-id="element-46" data-mp="1ektub2cg2owp">
          <p className="font-display text-[19px] font-bold uppercase leading-tight text-ink" data-id="element-47" data-mp="19u50vhh7fhux">
            Conocé como trabajamos
          </p>
          <p className="mx-auto mt-2 max-w-[44ch] font-sans text-[15px] leading-relaxed text-ink-soft" data-id="element-48" data-mp="1ohgfxtclhjzs">
            Hacé clic y descargá una muestra gratis de las planificaciones y
            actividades que ofrecemos.
          </p>
          <a href={SAMPLE_URL} target="_blank" rel="noopener noreferrer" className="mt-5 inline-flex min-h-[56px] w-full items-center justify-center gap-2 rounded-full border border-coral/40 bg-white px-6 font-sans text-[15px] font-bold uppercase tracking-[0.04em] text-coral transition-[transform,background-color,border-color] duration-150 ease-out hover:border-coral hover:bg-coral-soft/50 focus:outline-none focus-visible:ring-2 focus-visible:ring-coral focus-visible:ring-offset-2 active:scale-[0.98]" data-id="element-49" data-mp="1sl4lk6ho25ie">
            <DownloadIcon aria-hidden="true" className="h-5 w-5" data-id="element-50" data-mp="286rfvgmd0nx9" />
            Descargar muestra gratis
          </a>
        </div>
      </div>
    </section>;
}